import { render, staticRenderFns } from "./PortalSwitch.vue?vue&type=template&id=715613c2&scoped=true&"
import script from "./PortalSwitch.vue?vue&type=script&lang=js&"
export * from "./PortalSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PortalSwitch.vue?vue&type=style&index=0&id=715613c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715613c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('715613c2')) {
      api.createRecord('715613c2', component.options)
    } else {
      api.reload('715613c2', component.options)
    }
    module.hot.accept("./PortalSwitch.vue?vue&type=template&id=715613c2&scoped=true&", function () {
      api.rerender('715613c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/helpcenter/components/PortalSwitch.vue"
export default component.exports